import types from "prop-types";
import React, { useEffect, useRef, useState } from "react";

const PaginationWrapper = ({ onPaginate, styles, root, children, initialBind }) => {
	const [binded, setBinded] = useState(false);
	const page = useRef(0);
	const loadingRef = useRef(null);
	const isLoading = useRef(false);
	let observer = useRef(null);

	useEffect(() => {
		if (initialBind || !binded) {
			const rootElement = root?.current instanceof Element ? root.current : null;

			observer.current = new IntersectionObserver(handlePagination, {
				root: rootElement,
				rootMargin: "0px",
				threshold: 1.0,
			});
			observer.current.observe(loadingRef.current);
			setBinded(true);
		}
		return () => {
			if (observer.current) {
				observer.current.disconnect();
				setBinded(false);
			}
		};
	}, [initialBind, binded, root, onPaginate]); // Add root to the dependency array

	const handlePagination = (entities) => {
		const sentinelPos = loadingRef.current.getBoundingClientRect().bottom;
		const parentEnd = root?.current instanceof Element
			? root.current.getBoundingClientRect().bottom
			: window.innerHeight;
		if (parentEnd >= sentinelPos && !isLoading.current) {
			isLoading.current = true;
			page.current += 1;
			onPaginate(page.current, () => {
				isLoading.current = false;
			});
		}
	};

	return (
		<div
			style={{ width: "100%" }}
			className="pagination-wrapper">
			{children}
			<div
				ref={loadingRef}
				style={{ height: "50px", width: "100%" }}
				className="pagination-loading-ref"></div>
		</div>
	);
};

PaginationWrapper.propTypes = {
	onPaginate: types.func,
	styles: types.object,
	root: types.object, // Change this to object as it's a ref
	children: types.element,
	initialBind: types.bool,
};

export default PaginationWrapper;
